import * as React from 'react'
import type {SVGProps} from 'react'
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 10" {...props}>
        <path d="M10 4v2H0V4z" />
    </svg>
)
export default SvgMinus
